import React from 'react'

export const ButtonHoverAnimation = {
  whileHover: {
    scale: 1.03,
    boxShadow: "0 30px 90px -9px rgba(0,0,0,.2)",
    transition: { ease: 'easeInOut', duration: .5 },
  }
}
